import React, { FC } from 'react'
import Card from 'transfix-ui/components/Card'
import { makeStyles } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import { brandColors } from 'transfix-ui/theme/colors'
import { useLaneFiltersContext } from 'apps/fleet-planner/context'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import LaneDetails from '../LaneDetails'
import LanePickupDelivery from '../LanePickupDelivery'
import LoadsAvailableTag from '../LoadsAvailableTag'
import { getSavedLaneBookingFilters, getSavedLaneSourceSegment } from '../utils'

export interface ISavedLaneCardProps {
  savedLane: BookableShipmentSavedSearch
}

const useSavedLaneCardStyles = makeStyles(theme => ({
  card: {
    '&:hover': {
      backgroundColor: brandColors.coolGray1,
      cursor: 'pointer',
    },
  },
  savedLaneWrapper: {
    padding: theme.spacing(1.5),
  },
  laneDetailsWrapper: {
    margin: `0 0 ${theme.spacing(1)}`,
  },
}))

export const SavedLaneCard: FC<ISavedLaneCardProps> = ({ savedLane }) => {
  const { setTrackConversion } = useTrackConversionContext()
  const { changeParams, setHasStartedSearch } = useLaneFiltersContext()
  const classes = useSavedLaneCardStyles()
  const { trackEvent } = useFMSAnalytics()
  const { sourceType, totalResultCount = 0 } = savedLane || {}

  const cardClickHandler = () => {
    const sourceSegment = getSavedLaneSourceSegment(sourceType)
    if (sourceSegment) {
      setTrackConversion('web', sourceSegment)
    }

    trackEvent('Saved Lanes', 'CLICKED_SAVED_LANE_CARD')
    const filters = getSavedLaneBookingFilters(savedLane)
    changeParams({ filters })
    setHasStartedSearch(true)
  }

  return (
    <Box onClick={cardClickHandler}>
      <Card dataTest='saved-lane-card' className={classes.card} noPadding>
        <div className={classes.savedLaneWrapper}>
          <div className={classes.laneDetailsWrapper}>
            <LanePickupDelivery {...savedLane} />
            <LaneDetails {...savedLane} />
          </div>
          <LoadsAvailableTag loadsAvailableCount={totalResultCount} />
        </div>
      </Card>
    </Box>
  )
}

export default SavedLaneCard
